import React, { useRef, useState, useEffect } from 'react';
import cx from 'classnames';
import { Pagination, EffectFade, Navigation, Scrollbar, Keyboard } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AuthPromo } from '../../../cards/AuthPromo/index.js';
import '../../../cards/Card/index.js';
import '../../../cards/CategoryCard/index.js';
import '../../../cards/CryptoFeature/index.js';
import '../../../cards/GamePreview/index.js';
import '../../../cards/Promo/PromoCardSimple/index.js';
import '../../../cards/Promo/PromotionCard/index.js';
import '../../../cards/Provider/index.js';
import '../../../cards/SportsBook/index.js';
import '../../../cards/SecurityCard/index.js';
import '../../../cards/WinCard/index.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import { DirectionButton } from '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import styles from './index.module.scss.js';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

if (typeof gsap.registerPlugin === "function") {
  gsap.registerPlugin(useGSAP);
}
const AuthSlider = ({
  data = [],
  className,
  style
}) => {
  const swiperRef = useRef(null);
  const slidesRef = useRef([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const { contextSafe } = useGSAP();
  useEffect(() => {
    document.querySelectorAll(".modal-animate-image").forEach((el) => {
    });
    document.querySelectorAll(".modal-element-row").forEach((el) => {
      if (el instanceof HTMLElement) {
        el.style.opacity = "0";
      }
    });
    setTimeout(() => {
      gsap.fromTo(
        document.querySelectorAll(".modal-element-row"),
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          // вверх на 50px
          opacity: 1,
          stagger: 0.2,
          // задержка между словами
          duration: 0.4,
          ease: "power2.out"
        }
      );
    }, 200);
    gsap.to(".overflow-auth-slider", {
      scaleX: 0,
      transformOrigin: "left",
      // "сжимается" от правого края
      duration: 0.6,
      ease: "power2.inOut"
    });
    gsap.fromTo(
      ".modal-animate-image",
      {
        scale: 0,
        opacity: 0
      },
      {
        scale: 1,
        opacity: 1,
        duration: 0.6,
        ease: "power2.inOut"
      }
    );
    const elCurrent = slidesRef.current[0];
    gsap.fromTo(
      elCurrent?.querySelectorAll(".auth-promo-card__title span") || [],
      {
        y: 50,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        // задержка между словами
        duration: 0.4,
        ease: "power2.out"
      }
    );
    setTimeout(() => {
      gsap.fromTo(
        elCurrent?.querySelectorAll(".auth-promo-card__list-item") || [],
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          // вверх на 50px
          opacity: 1,
          stagger: 0.2,
          // задержка между словами
          duration: 0.6,
          ease: "power2.out"
        }
      );
    }, 800);
  }, []);
  const handleAnimateNext = contextSafe((i, iNext) => {
    setIsDisabled(true);
    const elCurrent = slidesRef.current[i];
    const elNext = slidesRef.current[iNext];
    gsap.fromTo(elCurrent?.querySelectorAll(".modal-animate-image img") || [], {}, {
      width: "0%",
      ease: "power2.out",
      duration: 0.6
    });
    gsap.fromTo(
      elCurrent?.querySelectorAll(".auth-promo-card__title span") || [],
      {
        y: 0,
        opacity: 1
      },
      {
        y: -50,
        opacity: 0,
        duration: 0.6,
        ease: "power2.out"
      }
    );
    elNext?.querySelectorAll(".auth-promo-card__list-item").forEach((item) => {
      item.style.opacity = "0";
    });
    gsap.fromTo(
      elCurrent?.querySelectorAll(".auth-promo-card__list-item") || [],
      {
        y: 0,
        opacity: 1
      },
      {
        y: -50,
        opacity: 0,
        duration: 0.6,
        ease: "power2.out"
      }
    );
    setTimeout(() => {
      swiperRef.current.slideTo(iNext);
      setIsDisabled(false);
      gsap.fromTo(elNext?.querySelectorAll(".modal-animate-image img") || [], {
        width: 0
      }, {
        width: "100%",
        ease: "power2.out",
        duration: 1.2
      });
      gsap.fromTo(
        elNext?.querySelectorAll(".auth-promo-card__title span") || [],
        {
          y: 50,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          stagger: 0.2,
          // задержка между словами
          duration: 0.4,
          ease: "power2.out"
        }
      );
      setTimeout(() => {
        gsap.fromTo(
          elNext?.querySelectorAll(".auth-promo-card__list-item") || [],
          {
            y: 50,
            opacity: 0
          },
          {
            y: 0,
            // вверх на 50px
            opacity: 1,
            stagger: 0.2,
            // задержка между словами
            duration: 0.6,
            ease: "power2.out"
          }
        );
      }, 800);
    }, 800);
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, /* @__PURE__ */ React.createElement(
    Swiper,
    {
      onSwiper: (swiper) => {
        swiperRef.current = swiper;
      },
      modules: [Pagination, EffectFade, Navigation, Scrollbar, Keyboard],
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      onSlideChange: (swiper) => {
        setCurrentSlide(swiper.realIndex);
        console.log("\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434:", swiper.realIndex);
      },
      speed: 1e3,
      navigation: {
        nextEl: ".button-next",
        prevEl: ".button-prev"
      },
      pagination: {
        el: ".pagination",
        clickable: true,
        renderBullet(index, classN) {
          return `<span class="${cx(classN, styles.bullet)}"></span>`;
        }
      },
      onBeforeInit: (swiper) => {
        swiper.navigation.init();
        swiper.navigation.update();
      },
      onAfterInit: (swiper) => {
        swiper.navigation.init();
        swiper.navigation.update();
      },
      onResize: (swiper) => {
        swiper.navigation.init();
        swiper.navigation.update();
      },
      className: styles["swiper-box"]
    },
    data.map((item, i) => /* @__PURE__ */ React.createElement(SwiperSlide, { className: styles["swiper-slide"], key: i }, /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: (el) => slidesRef.current[i] = el,
        className: styles.slideInner
      },
      /* @__PURE__ */ React.createElement(AuthPromo, { ...item })
    ))),
    /* @__PURE__ */ React.createElement("div", { className: styles.controls }, /* @__PURE__ */ React.createElement("div", { className: styles.controls__inner }, /* @__PURE__ */ React.createElement(
      DirectionButton,
      {
        direction: "prev",
        disabled: isDisabled || currentSlide === 0,
        onClick: () => {
          console.log("Previous slide clicked");
          handleAnimateNext(currentSlide, currentSlide - 1);
        }
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "pagination" }), /* @__PURE__ */ React.createElement(
      DirectionButton,
      {
        disabled: isDisabled || currentSlide === data.length - 1,
        direction: "next",
        onClick: () => {
          console.log("Next slide clicked");
          handleAnimateNext(currentSlide, currentSlide + 1);
        }
      }
    )))
  )), /* @__PURE__ */ React.createElement("div", { className: cx(styles.overflow, ["overflow-auth-slider"]) }));
};
AuthSlider.displayName = "AuthSlider";

export { AuthSlider };
//# sourceMappingURL=index.js.map
